__turbopack_context__.v({
  "heartIcon": "PhotographerPage-module__ImdMwq__heartIcon",
  "liked": "PhotographerPage-module__ImdMwq__liked",
  "mediaContent": "PhotographerPage-module__ImdMwq__mediaContent",
  "mediaLikes": "PhotographerPage-module__ImdMwq__mediaLikes",
  "mediaPicture": "PhotographerPage-module__ImdMwq__mediaPicture",
  "mediasGrid": "PhotographerPage-module__ImdMwq__mediasGrid",
  "sideInfos": "PhotographerPage-module__ImdMwq__sideInfos",
  "tags": "PhotographerPage-module__ImdMwq__tags",
  "tagsSelect": "PhotographerPage-module__ImdMwq__tagsSelect",
});
